export const WHITE_COLOR = 'var(--white)';
export const DEFAULT_TEXT_STYLE = {
    color: WHITE_COLOR,
    fontSize: '14px',
    fontFamily: 'Source Sans Pro',
};
export const LABEL_STYLE = Object.assign({}, DEFAULT_TEXT_STYLE);
export const DATE_FORMAT = 'dd-MMM-yyyy';
export const PAGE_BG_COLOR = '#1f2329';
export const GRID_LINE_COLOR = '#41454A';
export const POSITIVE_COLOR = '#4B87CD';
export const TIMECHART_COLORS = [POSITIVE_COLOR, '#4B52CD', '#9A4BCD'];
export const DEFAULT_OPTIONS = {
    chart: {
        backgroundColor: PAGE_BG_COLOR,
    },
    title: {
        text: '',
    },
    subtitle: {
        text: '',
    },
    tooltip: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    credits: {
        enabled: false,
    },
    exporting: {
        buttons: {
            contextButton: {
                menuItems: [
                    'downloadPNG',
                    'downloadJPEG',
                    'downloadPDF',
                    'downloadSVG',
                ],
            },
        },
    },
    navigation: {
        buttonOptions: {
            theme: {
                fill: '#2c3239',
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                states: {
                    hover: {
                        fill: '#2c3239',
                    },
                    select: {
                        fill: '#2c3239',
                    },
                },
            },
        },
        menuStyle: {
            background: PAGE_BG_COLOR,
            boxShadow: 'none',
            borderColor: '#42474c',
        },
        menuItemStyle: {
            color: 'white',
            fontFamily: 'Source Sans Pro',
        },
        menuItemHoverStyle: {
            backgroundColor: ' #343b44',
        },
    },
};
//# sourceMappingURL=index.js.map